import {events} from "../../bootstrap/components/events";
import {toast} from "../../bootstrap/components/toast";
import {readUrl} from "../../bootstrap/components/read-url";

const ChangeAvatarApp = function (config, $) {
    const app = this;

    const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg'];

    let ajax = null;

    app.elms = {};
    app.elms.$wrap = $(config.wrap);
    app.elms.$img = app.elms.$wrap.find('img');
    app.elms.$file = app.elms.$wrap.find('input:file');
    app.elms.$btn = app.elms.$wrap.find('button:submit');

    app.fileUploadChange = function (el, e) {
        const maxSize = el.getAttribute('data-max-size'); // 2MB in bytes

        if (el.files.length > 0) {
            const file = el.files[0];

            if (!allowedTypes.includes(file.type)) {
                toast.danger('Only PNG, JPG, and JPEG files are allowed.')
                e.preventDefault();
                return;
            }

            if (file.size > maxSize) {
                toast.danger('Max size is less than 2MB');
                e.preventDefault();

                return;
            }
        }

        readUrl(el, app.elms.$img);
    }

    app.saveAvatar = function (form, e) {

        e.preventDefault();

        if (ajax) return;

        const data = new FormData();

        const files = app.elms.$file[0].files;

        if (files.length > 0)
            data.append("avatar", files[0]);
        else {
            toast.warning('No file chose');
            return;
        }

        ajax = $.ajax({
            url: form.getAttribute("action"),
            type: form.getAttribute("method"),
            data: data,
            processData: false,
            contentType: false,
            beforeSend: function () {
                app.elms.$btn.addClass('progressing');
            },
            success: function(res) {
                toast.success();
            },
            error: function(jqXHR, textStatus, errorThrown) {
                toast.error('Unexpected error');
                console.error("Error:", textStatus, errorThrown);
            },
            complete: function () {
                app.elms.$btn.removeClass('progressing');
                ajax = null;
            }
        });

    }

    app.init = function () {

        events.bind(app.elms.$wrap, app);

        return this;
    }
}

addEventListener('DOMContentLoaded', function () {
    new ChangeAvatarApp({wrap: '.wwAr'}, jQuery).init();
})